import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=c4b839f6&"
import script from "./Paginacao.vue?vue&type=script&lang=js&"
export * from "./Paginacao.vue?vue&type=script&lang=js&"
import style0 from "./Paginacao.vue?vue&type=style&index=0&id=c4b839f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports